// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { Card, CardProps, alpha, styled } from "@mui/material";

export const CardContainer = styled(Card)<
  CardProps & { selected?: boolean; disabled?: boolean }
>(
    ({ theme, selected, disabled }) => `
    background-color: ${
    !disabled
        ? selected
            ? alpha(
                theme.palette.primary.main,
                theme.palette.action.selectedOpacity
            )
            : undefined
        : theme.palette.action.hover
};
        cursor: pointer;
        text-decoration: ${disabled ? "line-through" : "none"};
        margin: .5rem;
        border: 1px solid;
        border-color: ${theme.palette.divider};

        &:hover {
            background: ${
    selected
        ? alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity +
                      theme.palette.action.hoverOpacity
        )
        : theme.palette.action.hover
};
        }
    `
);
